<script lang="ts">
	import type { SvelteSet } from 'svelte/reactivity'
	import type { SearchField } from 'utility/search-fields'
	import type { i18n } from 'types/common'

	import { graphql } from '$houdini'
	import { onMount, type ComponentProps } from 'svelte'
	import Autocomplete from '@isoftdata/svelte-autocomplete'
	import EditModeControls from 'components/search/EditModeControls.svelte'
	import Pin from 'components/search/Pin.svelte'
	import { getContext } from 'svelte'

	interface Props extends Omit<ComponentProps<typeof Autocomplete<string | null>>, 'options' | 'value' | 'emptyValue'> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		titleType?: string | null
		label?: string
	}

	const { t: translate } = getContext<i18n>('i18next')

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		titleType = $bindable(null),
		label = translate('common:titleType', 'Title Type'),
		...rest
	}: Props = $props()

	let titleTypes: Array<string> = $state([])

	const getTitleTypesQuery = graphql(`
		query VehicleTitleTypes {
			vehicleTitleTypes
		}
	`)

	onMount(async () => {
		const res = await getTitleTypesQuery.fetch({ policy: 'CacheOrNetwork' })
		titleTypes = res.data?.vehicleTitleTypes ?? []
	})
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<Autocomplete
		{...rest}
		{label}
		options={titleTypes}
		emptyValue={null}
		bind:value={titleType}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</Autocomplete>
</EditModeControls>
